import React from 'react';
import { portfolioData } from '../mock';
import { useReveal } from '../hooks/useReveal';

const AchievementCard = ({ item, index }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`achievement-${index}`}
      className={`reveal ${visible ? 'is-visible' : ''} p-7 border border-[hsl(var(--rule))] rounded-sm bg-[hsl(var(--background))] hover:border-[hsl(var(--accent))] transition-all group`}
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="mono text-[0.7rem] text-[hsl(var(--accent))] mb-5 tracking-wider">
        // {String(index + 1).padStart(2, '0')}
      </div>
      <h3 className="display text-2xl leading-snug mb-3">
        {item.title}
      </h3>
      <p className="text-[hsl(var(--foreground-muted))] leading-relaxed mb-5">
        {item.description}
      </p>
      <div className="mono text-[0.7rem] text-[hsl(var(--foreground-faint))] uppercase tracking-wider">
        {item.organization}
      </div>
    </div>
  );
};

const Achievements = () => {
  return (
    <section
      id="achievements"
      data-testid="achievements-section"
      className="py-28 sm:py-36 px-5 sm:px-8 lg:px-12 border-t border-[hsl(var(--rule))]"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16 mb-14">
          <div className="lg:col-span-4">
            <div className="section-label mb-6">
              <span>05 / small wins</span>
            </div>
            <h2 className="display text-4xl sm:text-5xl leading-tight">
              A few moments
              <br />
              I'm proud of.
            </h2>
          </div>
          <div className="lg:col-span-8 lg:pt-3">
            <p className="text-xl text-[hsl(var(--foreground-muted))] leading-relaxed max-w-2xl">
              Leadership, hackathons, and a healthy obsession with shipping things on tight deadlines.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {portfolioData.achievements.map((a, i) => (
            <AchievementCard key={a.id} item={a} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
